// Native
import { forwardRef, useEffect, useState } from "react"
import DatePicker from "react-datepicker"

// Components
import { Box, HStack, Text } from "@chakra-ui/react"
import { Pressable } from "components"

export default function Interval({ initial, label, onSelect = () => {}, onChange:onChangeCallback = () => {}, ...props }){

    const [ period, setPeriod ] = useState(initial ?? [new Date(), new Date()])

    useEffect(() => {
        onChangeCallback(period)
        if(!!period?.[1]) onSelect(period)
    }, [period])

    const Input = forwardRef(({ value, onClick }, ref) => (
        <Pressable disabled onClick={onClick}>
            <Box
                mx={4}
                py={2}
                px={4}
                bgColor="rgba(0,0,0,0)"
                borderRadius={5}
                width="180px"
                border="1px solid"
                borderColor="rgba(255, 255, 255, 0.16)"
                minHeight="40px"         // altura mínima fixa para evitar encolher
                display="flex"
                alignItems="center"      // centralizar verticalmente o texto
            >
                <Text
                    fontSize="xs"
                    fontWeight="bold"
                >
                    {value && value.trim() ? value : 'Selecione o intervalo'}
                </Text>

            </Box>

        </Pressable>
    ))

    return(
        <HStack>
            { label && <Text children={label} fontSize="sm" color="GrayText" />}
            <DatePicker 
                selected={period?.[0]}
                startDate={period?.[0]}
                endDate={period?.[1]}
                onChange={setPeriod}
                value={period}
                selectsRange
                selectsDisabledDaysInRange
                isClearable
                withPortal
                dateFormat="dd/MM/YYYY"
                customInput={<Input />}
                {...props}
            />

        </HStack>
    )
}